var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeliverability = function SvgDeliverability(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "deliverability",
    transform: "translate(-666.537)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(666.537)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "analytics_FILL0_wght300_GRAD-25_opsz20",
    d: "M173.918-779.27h.932v-3.459h-.932Zm5.774,0h.932v-7.143h-.932Zm-2.879,0h.932v-2.541h-.932Zm0-3.459h.932v-1.321h-.932Zm-4.372,6a1.128,1.128,0,0,1-.828-.341,1.128,1.128,0,0,1-.341-.828v-9.661a1.128,1.128,0,0,1,.341-.828,1.128,1.128,0,0,1,.828-.341H182.1a1.128,1.128,0,0,1,.828.341,1.128,1.128,0,0,1,.341.828v9.661a1.128,1.128,0,0,1-.341.828,1.128,1.128,0,0,1-.828.341Zm0-.932H182.1a.229.229,0,0,0,.164-.075.229.229,0,0,0,.075-.164v-9.657a.229.229,0,0,0-.075-.164.229.229,0,0,0-.164-.075h-9.657a.229.229,0,0,0-.164.075.229.229,0,0,0-.075.164v9.657a.229.229,0,0,0,.075.164A.229.229,0,0,0,172.442-777.661ZM172.2-787.8v0Z",
    transform: "translate(501.266 794.729)",
    fill: "#28ad56"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliverability, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deliverability.3d28f732.svg";
export { ForwardRef as ReactComponent };